<template>
  <b-modal
    id="login-modal"
    centered
    ref="login-modal"
    :title="modalTitle"
    cancel-title="انصراف"
    ok-title="ورود"
    @ok="checkForm"
  >
    <form ref="form" @submit.stop.prevent="checkForm">
      <b-form-group
        :state="!mobileHasError"
        :label="mobileLabel"
        label-for="mobile-input"
        :invalid-feedback="mobileErrorMessage"
      >
        <b-form-input
          id="mobile-input"
          type="text"
          :placeholder="mobileLabel"
          name="mobile"
          v-model="mobile"
          @keyup="checkMobileOnKeyUp(mobile)"
          :state="!mobileHasError"
          required
          is-invalid="true"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        :state="!passwordHasError"
        :label="passwordLabel"
        label-for="password-input"
        :invalid-feedback="passwordErrorMessage"
      >
        <b-form-input
          id="password-input"
          type="password"
          :placeholder="passwordLabel"
          name="password"
          v-model="password"
          @keyup="checkPasswordOnKeyUp(password)"
          :state="!passwordHasError"
          required
        ></b-form-input>
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import { isValidMobile } from "../../validators";

export default {
  name: "login-component",

  data() {
    return {
      modalTitle: "ورود",
      modalTitleLoggedIn: "وارد شده!",
      primaryBtnLabel: "Fazer Login",
      mobileLabel: "موبایل",
      passwordLabel: "کلمه عبور",
      mobileErrorMessage: "",
      mobileReqiuredMessage: " موبایل ضروری است",
      passwordErrorMessage: "",
      passwordReqiuredMessage: "کلمه عبور ضروری است",
      mobileNotValidMessage: "موبایل معتبر نیست",
      btnLoggedInLabel: "ورود",
      mobilePlaceholder: "موبایل",
      mobile: "",
      password: "",
      mobileHasError: false,
      passwordHasError: false,
      isFormSuccess: false,
    };
  },

  computed: {
    isUserLoggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
    openModal() {
      if (this.$store.getters.isLoginModalOpen) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    closeModal() {
      this.$refs["login-modal"].hide();
      this.$store.commit("showLoginModal", false);
    },

    checkForm(e) {
      e.preventDefault();

      if (!this.mobile) {
        this.mobileHasError = true;
        this.mobileErrorMessage = this.mobileReqiuredMessage;
      } else {
        if (this.mobile && !isValidMobile(this.mobile)) {
          this.mobileHasError = true;
          this.mobileErrorMessage = this.mobileNotValidMessage;
        } else {
          this.mobileHasError = false;
        }
      }

      if (!this.password) {
        this.passwordHasError = true;
        this.passwordErrorMessage = this.passwordReqiuredMessage;
      } else {
        this.passwordHasError = false;
      }

      if (!this.mobileHasError && !this.passwordHasError) {
        this.isFormSuccess = true;

        this.$store
          .dispatch("login", {
            mobile: this.mobile,
            password: this.password,
          })
          .then(() => {
            this.$store.dispatch("getUser");
            this.closeModal();
          })
          .catch((error) => {
            console.log(error.message);
          });
      }
    },

    checkMobileOnKeyUp(mobileValue) {
      if (mobileValue && isValidMobile(mobileValue)) {
        this.mobileHasError = false;
      } else {
        this.mobileHasError = true;

        if (mobileValue) {
          this.mobileErrorMessage = this.mobileNotValidMessage;
        } else {
          this.mobileErrorMessage = this.mobileReqiuredMessage;
        }
      }
    },

    checkPasswordOnKeyUp(passwordValue) {
      if (passwordValue) {
        this.passwordHasError = false;
      } else {
        this.passwordHasError = true;
      }
    },
  },
};
</script>

<style lang="scss">
.fa-exclamation-circle {
  color: red;
}
.fa-check {
  color: green;
}
</style>


